import { render, staticRenderFns } from "./LensAccountModal.vue?vue&type=template&id=5f28c73c&scoped=true"
import script from "./LensAccountModal.vue?vue&type=script&lang=js"
export * from "./LensAccountModal.vue?vue&type=script&lang=js"
import style0 from "./LensAccountModal.vue?vue&type=style&index=0&id=5f28c73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28c73c",
  null
  
)

export default component.exports